import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { getIsMarketOptional } from 'dash-common';
import { Flex, Form, FormContext } from 'dash-ui';
import { FormFields } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants';
import useValidation from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/hooks/useValidation';
import { useGetMarketAreasQuery } from 'gql/generated.graphql';

const MarketAreaSelect = () => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formErrors, formState, stateHandlers } = useContext(FormContext);
  const valid = useValidation();
  const { state = '' } = formState || {};

  const { data: result } = useGetMarketAreasQuery({
    variables: {
      filter: {
        stateNames: state && [state],
      },
      pagination: {
        allowLimit: false,
      },
      sort: {
        fieldName: 'name',
        sortOrder: 1,
      },
    },
    fetchPolicy: 'network-only',
  });

  const { marketAreas } = useMemo(
    () => ({
      marketAreas: result?.getMarketAreas?.collection || [],
    }),
    [result]
  );

  const isMarketOptional = getIsMarketOptional(state);

  const onSelect = (fieldName: FormFields) => (value: string) => {
    stateHandlers[fieldName](value);
    if (!isMarketOptional) {
      valid(fieldName, value);
    }
  };

  return (
    <Flex flexDirection="column" flex={1}>
      <Form.Label required={!isMarketOptional}>
        {t('forms:labels.marketArea')}
      </Form.Label>
      <Form.Select
        disabled={isMarketOptional}
        menuPortalZIndex="auto"
        value={formState.market}
        options={marketAreas.map(({ _id, name }) => ({
          label: name,
          value: _id,
        }))}
        placeholder={t('forms:placeholders.selectOne')}
        w="100%"
        onChanged={onSelect(FormFields.Market)}
        $errorType={formErrors[FormFields.Market]?.type}
      />
      <Form.Feedback $errorType={formErrors[FormFields.Market]?.type}>
        {formErrors[FormFields.Market]?.message}
      </Form.Feedback>
    </Flex>
  );
};

export default MarketAreaSelect;
